module.exports = __webpack_public_path__ + "67a1df2bd66176b32dab117a6a71c6c9.png";